/**
 * Responsible for combining all floating label related callers and exposing it
 * as a jQuery plugin.
 * @module elements/fields/floatingLabelPlugin
 */
import { createJQueryPlugin } from './form-field-behaviors';
import stateModifiers from './state-modifiers';
import iconifyBehaviors from './iconify-behaviors';
import iconifyDetails from './iconify-details';
import floatingError from './floating-error';

/**
 * Defines any built in callers for a floating label.
 * @type {Array}
 */
const BUILTIN_BEHAVIORS = [
  stateModifiers(),
  iconifyBehaviors(),
  iconifyDetails(),
  floatingError(),
];

export default createJQueryPlugin('floatingLabel', 'floating-label', BUILTIN_BEHAVIORS);



// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/fields/floating-label-plugin.js